import React from 'react'

import clsx from 'clsx'

import Divider from './components/Divider'

import classes from './HowToUseItem.module.scss'

/** @type {import("./types").default} */
const HowToUseItem = ({ title, icon, index, isLast }) => {
  return (
    <>
      <div className={clsx('HowToUseItem', classes.root)}>
        <div className={classes.topContent}>
          <p className={classes.index}>0{index + 1}</p>
          <img src={icon} alt="icon" className={classes.iconCont} />
        </div>
        <p className={classes.title}>{title}</p>
      </div>
      {!isLast && <Divider />}
    </>
  )
}

export default HowToUseItem
